import { useMemo, useState, type ComponentProps } from "react";
import { Select } from "@/shared/components/shadcn/Select";
import { isUsTimezone, timezoneLabel, timezoneOptions } from "@/shared/utils/timezones";

type TimezoneSelectProps = Omit<ComponentProps<typeof Select>, "value" | "children"> & {
  value: string;
};

export function TimezoneSelect({ value, ...props }: TimezoneSelectProps) {
  const [initialValue] = useState(value);
  const options = useMemo(() => [...new Set([
    ...timezoneOptions(value), ...(isUsTimezone(initialValue) ? [initialValue] : []),
  ])], [value, initialValue]);
  const valid = isUsTimezone(value);
  return (
    <Select {...props} value={value} aria-invalid={!valid || props["aria-invalid"]}>
      {!valid && <option value={value} disabled>{value ? `Unsupported U.S. timezone: ${value}` : "Select a U.S. timezone"}</option>}
      {options.map((zone) => <option key={zone} value={zone}>{timezoneLabel(zone)}</option>)}
    </Select>
  );
}
